import { UserAgent } from "./userAgent"

type IsBotResponse = {
  isBot: boolean
}

export async function isBot() {
  try {
    const response = await fetch("https://marketing.bounce.com/api/is-bot")
    if (!response.ok) {
      return UserAgent.isBot()
    }

    const data: IsBotResponse = await response.json()

    return data.isBot
  } catch {
    return UserAgent.isBot()
  }
}
